<template>
  <div class="match-reward-page page-max-width">
      <MatchBackHomeButton />
    <MatchRewardCashPrizeSection :cash-prize-data="matchRewardCashPrizeData" />
    <div class="individual-prize-section-wrapper">
      <MatchRewardIndividualPrizeSection :individual-prize-data="matchRewardIndividualPrizeData" />
    </div>
    <MatchPageFooter />
  </div>
</template>

<script>
import MatchBackHomeButton from '@/components/match/common/MatchBackHomeButton.vue'
import MatchRewardCashPrizeSection from '@/components/match/reward/MatchRewardCashPrizeSection.vue'
import MatchRewardIndividualPrizeSection from '@/components/match/reward/MatchRewardIndividualPrizeSection.vue'
import MatchPageFooter from '@/components/match/common/MatchPageFooter.vue'
import { matchRewardCashPrizeData, matchRewardIndividualPrizeData } from '@/data/match/matchReward'

export default {
  name: 'MatchReward',
  components: { MatchBackHomeButton, MatchRewardCashPrizeSection, MatchRewardIndividualPrizeSection, MatchPageFooter },
  data() {
    return { matchRewardCashPrizeData, matchRewardIndividualPrizeData }
  },
}
</script>

<style lang="scss" scoped>
.match-reward-page {
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  box-sizing: border-box;
  padding-top: 6.140625rem;
  background: #d6dbe1 url('@/assets/image/match/pc/match/reward-page-bg.jpg') center top / 100% auto no-repeat;
}



.individual-prize-section-wrapper {
  margin-top: 0.088542rem;
}

@media (max-width: 750px) {
  .match-reward-page {
    padding-top: 121.4vw;
    background-image: url('@/assets/image/match/pc/match/1.jpg');
    background-size: 100% auto;
  }


  .individual-prize-section-wrapper {
    margin-top: 8vw;
  }
}
</style>
